import React from 'react'
import {commonStyleObj} from '../utils/utils'

function userNameReducer(currUser, newUser) {
    return newUser
}
  
const defaultUser = 'Tony'
  
function NameInput() {
    const [user, setUser] = React.useReducer(userNameReducer, defaultUser)
    const handleChange = e => setUser(e.target.value)
    return (
      <div style={commonStyleObj}>
        <h3>User Reducer Example</h3>
        <label>
          User Name: <input value={user} onChange={handleChange} />
        </label>
        <h3>You typed: {user}</h3>
      </div>
    )
}

export default NameInput